import {FlewMessageDefinition} from './flew.types';
export class FlewMessage extends Error {

    body: string;
    header: string;
    translatable: boolean;
    congruent: string;
/**
 * @param {?} definition
 */
constructor(definition: FlewMessageDefinition) {
        super();
        const {body, header, translatable = true, congruent} = definition;
        this.congruent = congruent;
        this.body = congruent || body;
        this.header = congruent || header;
        this.translatable = translatable;
    }

}

function FlewMessage_tsickle_Closure_declarations() {
/** @type {?} */
FlewMessage.prototype.body;
/** @type {?} */
FlewMessage.prototype.header;
/** @type {?} */
FlewMessage.prototype.translatable;
/** @type {?} */
FlewMessage.prototype.congruent;
}

